import React, { useState } from "react"
import bgMenu from "./bg-menu.png"

type Props = { onZpet: () => void }

function formatTime(seconds: number) {
  if (seconds >= 3600) {
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60
    return `${h}h ${m}min ${s}s`
  }
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m}m ${s}s`
}

export default function Zebricek({ onZpet }: Props): React.ReactElement {
  const [refreshKey, setRefreshKey] = useState(0)
  let scores = [] as Array<{ jmeno: string; cookies: number; postava?: string; datum?: string }>
  try { scores = JSON.parse(localStorage.getItem("zebricek") || "[]") } catch (e) { scores = [] }
  scores.sort((a, b) => b.cookies - a.cookies)
  const top = scores.slice(0, 20)
  
  const sortedByDate = [...scores].sort((a, b) => new Date(b.datum || 0).getTime() - new Date(a.datum || 0).getTime());
  const lastAttempt = sortedByDate[0];

  return (
    <div className="zebricek-root">
      <div
        aria-hidden
        style={{
          position: "fixed",
          inset: 0,
          zIndex: -1,
          pointerEvents: "none",
          backgroundImage: `url(${bgMenu})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.1
        }}
      />
      <style>{`
        .zebricek-wrap {
          max-height: 400px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #334155 #0f172a;
        }
        .zebricek-wrap::-webkit-scrollbar { width: 8px; }
        .zebricek-wrap::-webkit-scrollbar-track { background: #0f172a; }
        .zebricek-wrap::-webkit-scrollbar-thumb { background: #334155; border-radius: 4px; }
      `}</style>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 20 }}>
        <h1>🏆 Žebříček</h1>
      </div>

      {top.length === 0 ? (
        <p>Žádná skóre zatím.</p>
      ) : (
        <div className="zebricek-wrap">
          <table className="zebricek-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Jméno</th>
                <th>Postava</th>
                <th>Sušenky</th>
              </tr>
            </thead>
            <tbody>
              {top.map((s, i) => (
                <tr key={i} className={s === lastAttempt ? "zebricek-row-current" : ""}>
                  <td>{i + 1}</td>
                  <td>{s.jmeno}</td>
                  <td>{s.postava || ''}</td>
                  <td>{s.cookies}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
        <button className="pixel-button" onClick={() => { setRefreshKey((k) => k + 1) }}>Refresh</button>
        <button className="pixel-button" onClick={onZpet} style={{ marginLeft: 8 }}>← Zpět</button>
      </div>
    </div>
  )
}
